var _style, _g, _pattern, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquare2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.3 97.3",
    style: {
      enableBackground: "new 0 0 97.3 97.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#858589;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st5{fill:#FA9A63;}\n\t.st6{fill:#FADC63;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st9{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st10{fill:url(#SVGID_00000049208370704256177900000004083275537179570308_);stroke:#000000;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("pattern", {
    x: -1371.4,
    y: -724.2,
    width: 85,
    height: 102.8,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_2",
    viewBox: "6.3 -110.9 85 102.8",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: -110.9,
    className: "st0",
    width: 85,
    height: 102.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.4-16.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66-20.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.9-16.8c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5-20.8c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85-42.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.6-46.5c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 75.6,
    y1: -21.3,
    x2: 85.9,
    y2: -31.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.5-42.5c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.1-46.5c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 33.1,
    y1: -21.3,
    x2: 43.4,
    y2: -31.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0-42.5c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.3-72.1c4.3,3.4,5,9.6,1.7,13.9s-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 86.2,
    y1: -47,
    x2: 96.5,
    y2: -57.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.1-68.2c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.7-72.1c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 43.7,
    y1: -47,
    x2: 54,
    y2: -57.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6-68.2c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1.2,
    y1: -47,
    x2: 11.5,
    y2: -57.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.9-97.8c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.8-93.9c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.4-97.8c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 54.3,
    y1: -72.7,
    x2: 64.6,
    y2: -83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.3-93.9c2.3-1.5,6.6,1.1,9.5,5.7s3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.8-97.8c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11.8,
    y1: -72.7,
    x2: 22.1,
    y2: -83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.4-119.6c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66-123.5c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65,
    y1: -98.4,
    x2: 75.2,
    y2: -108.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.9-119.6c2.3-1.5,6.6,1.1,9.5,5.7c3,4.6,3.5,9.6,1.2,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5-123.5c4.3,3.4,5,9.6,1.7,13.9c-3.4,4.3-9.6,5-13.9,1.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 22.4,
    y1: -98.4,
    x2: 32.7,
    y2: -108.7
  }))))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern_2",
    patternTransform: "matrix(1 0 0 1 164.8179 -3.6235)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st9",
    width: 96.3,
    height: 96.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare2);
export default __webpack_public_path__ + "static/media/Square2.39a8820f11b44d2e00629a98b69167d8.svg";
export { ForwardRef as ReactComponent };